<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="group._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ group.title }}</h3>
            <p class="text-center">{{ group.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات گروه</h4>
          </div>
          <div class="widget-body">
            <form id="groupForm" class="form-horizontal">
              <!-- group name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام گروه</label>
                <div class="col-lg-6">
                  <input type="text" name="groupName" class="form-control" v-model="group.title" />
                </div>
              </div>

              <!-- is level based -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">بر اساس حداقل سطح</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="group.isLevelBased">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- min level -->
              <div v-if="group.isLevelBased" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">حداقل سطح</label>
                <div class="col-lg-6">
                  <input type="number" name="minLevel" class="form-control" min="1" v-model="group.minLevel" />
                </div>
              </div>

              <!-- is play count based -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >بر اساس حداقل تعداد بازی</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="isPlayCountBased" id="" v-model="group.isPlayCountBased">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is iran check active -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >بر اساس موقعیت جغرافیایی</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="isIranCheckActive" id="" v-model="group.isIranCheckActive">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is iran based -->
              <div v-if="group.isIranCheckActive" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >کاربرانی که یک بار با ip ایرانی وصل شده اند</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="usersFromIR" id="" v-model="group.usersFromIR">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">کاربران ایرانی</option>
                    <option :value="false">کاربران غیر ایرانی</option>
                  </select>
                </div>
              </div>

              <!-- min play count -->
              <div v-if="group.isPlayCountBased" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">حداقل تعداد بازی</label>
                <div class="col-lg-6">
                  <input type="number" name="minPlayCount" class="form-control" min="1" v-model="group.minPlayCount" />
                </div>
              </div>

              <!-- is platform based -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">بر اساس پلتفرم</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isPlatformBased" id="" v-model="group.isPlatformBased">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- is platform based -->
              <div v-if="group.isPlatformBased" class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >پلتفرم ها را انتخاب کنید</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="isPlatformBased" id="" v-model="group.platforms" multiple>
                    <option value="" disabled>انتخاب کنید</option>
                    <option v-for="splash in splashes" :key="splash._id" :value="splash._id">{{
                      splash.platform
                    }}</option>
                  </select>
                </div>
              </div>

              <div v-else>
                <!-- is build number based -->
                <div class="form-group row d-flex align-items-center mb-5">
                  <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">بر اساس build number</label>
                  <div class="col-lg-6">
                    <select class="form-control" name="isLevelBased" id="" v-model="group.isBuildNumberBased">
                      <option value="" disabled>انتخاب کنید</option>
                      <option :value="true">فعال</option>
                      <option :value="false">غیر فعال</option>
                    </select>
                  </div>
                </div>

                <!-- min play count -->
                <div v-if="group.isBuildNumberBased">
                  <div
                    v-for="splash in splashes"
                    :key="splash._id"
                    class="form-group row d-flex align-items-center mb-5"
                  >
                    <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                      ><b>{{ splash.platform }}</b>
                    </label>
                    <div class="col-lg-6">
                      <input type="text" :name="`buildnumbers-${splash.platform}`" class="form-control" />
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="id">
                <h2>کاربران ثابت این گروه</h2>
                <div class="table-responsive">
                  <table id="sorting-table" class="table mb-0">
                    <thead>
                      <tr>
                        <th>نام کاربری</th>
                        <th>زمان ورود به گروه</th>
                        <th>جزییات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(userInfo, index) in group.users" :key="userInfo.user._id">
                        <td>{{ userInfo.user.username }}</td>
                        <td>{{ new Date(userInfo.addDate).toLocaleDateString('fa-IR') }}</td>
                        <td>
                          <div class="ml-auto">
                            <router-link :to="{ path: '/dashboard/user', query: { id: userInfo.user._id } }"
                              >مشاهده</router-link
                            >
                          </div>
                          <div class="mr-auto">
                            <button class="btn btn-danger mx-3" @click="removeFromGroup(index)">حذف از گروه</button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/UserGroups">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import groupService from '../../../../services/UsersRulePermissions';
import splashService from '../../../../services/Splash';
export default {
  name: 'groupdetail',
  data() {
    return {
      group: {},
      splashes: [],
      id: null,
    };
  },
  created() {
    this.getSplashes();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getGroup(this.id);
    }
  },
  methods: {
    async getSplashes() {
      try {
        const splashes = await splashService.getSplashs({});
        this.splashes = splashes;
      } catch (err) {
        console.log(err);
      }
    },
    async getGroup(id) {
      try {
        const group = await groupService.getGroup(id);
        this.group = group;
        setTimeout(() => {
          if (group.isBuildNumberBased) {
            const form = document.getElementById('groupForm');
            for (let i = 0; i < this.splashes.length; i++) {
              const splash = this.splashes[i];
              const index = group.buildNumbers.findIndex(buildnumber => buildnumber.platform == splash._id);
              if (index >= 0) {
                const str = group.buildNumbers[index].buildNumbers.join(',');
                form[`buildnumbers-${splash.platform}`].value = str;
              }
            }
          }
        }, 200);
      } catch (err) {
        console.log(err);
      }
    },
    async removeFromGroup(index) {
      this.group.users.splice(index, 1);
    },
    async save() {
      const form = document.getElementById('groupForm');
      const body = this.group;
      const buildNumbers = [];
      if (this.group.isBuildNumberBased) {
        for (let i = 0; i < this.splashes.length; i++) {
          const splash = this.splashes[i];
          const buildNumbersStr = form[`buildnumbers-${splash.platform}`].value;
          if (buildNumbersStr && buildNumbersStr.trim() !== '') {
            const buildArrays = buildNumbersStr.split(',').map(str => parseInt(str.trim()));
            if (buildNumbersStr && buildArrays.length > 0) {
              const buildNumbersInfo = {
                platform: splash._id,
                buildNumbers: buildArrays,
              };
              buildNumbers.push(buildNumbersInfo);
            }
          }
        }
      }
      body.buildNumbers = buildNumbers;
      let id;
      try {
        if (this.id) {
          await groupService.editGroup(body);
          id = this.id;
          window.notif({ mssg: 'تغییرات انجام شد', isError: false });
        } else {
          const group = await groupService.addGroup(body);
          id = group._id;
          this.id = id;
          window.notif({ mssg: 'گروه جدید با موفقیت ساخته شد', isError: false });
        }

        this.getGroup(id);
      } catch (err) {
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },
  },
};
</script>
